module.exports = __webpack_public_path__ + "img/io.3d2c2aa3.svg";